<!-- Поле номера заказа с доступом к настройкам нумератора. -->
<template>
  <NumeratorField
    :model-value="modelValue"
    label="Номер заказа"
    input-id="number"
    input-class="form-input"
    target-model="Order"
    :required="required"
    :filled="filled"
    :editable="editable"
    :invalid="invalid"
    :error-text="errorText"
    @update:modelValue="$emit('update:modelValue', $event)"
  />
</template>

<script>
import NumeratorField from "@/components/Numerator/Field.vue";

export default {
  name: "OrderNumberField",

  components: {
    NumeratorField,
  },

  props: {
    modelValue: {
      type: [String, Number],
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    filled: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: "Поле обязательно для заполнения",
    },
  },

  emits: ["update:modelValue"],
};
</script>
